import React from "react";
import EntityDropdown from "../../../component/EntityDropdown";
import { POINTS_ADMIN } from "../../../config/lang";
import { translate } from "../../../util/util";
import { AUDIENCE_TARGET_TYPES } from "./questionOptions";

// A survey targets exactly one of points / point_groups / networks (enforced server-side).
// This field shows a single target-type selector plus one multi-select for whichever type is
// active, and clears the other two keys on change so the invalid multi-target combination can
// never be produced from this UI. It writes directly into item.points/point_groups/networks
// rather than into its own "audience" key.
const hasValue = v => Array.isArray(v) && v.length > 0;

export default function AudienceField({ item = {}, onChange, lang }) {
  const activeKey = (AUDIENCE_TARGET_TYPES.find(t => hasValue(item[t.key])) || AUDIENCE_TARGET_TYPES[0]).key;
  const active = AUDIENCE_TARGET_TYPES.find(t => t.key === activeKey);

  const setTargetType = key => {
    AUDIENCE_TARGET_TYPES.forEach(t => onChange(t.key, t.key === key ? (item[t.key] || []) : []));
  };

  return (
    <div className="pt-audience">
      <label className="mp-form-label">{translate(POINTS_ADMIN, "audience_target_type", lang)}</label>
      <select
        className="mp-form-input pt-audience-select"
        value={activeKey}
        onChange={e => setTargetType(e.target.value)}
      >
        {AUDIENCE_TARGET_TYPES.map(t => (
          <option key={t.key} value={t.key}>{translate(POINTS_ADMIN, t.labelKey, lang)}</option>
        ))}
      </select>
      <EntityDropdown
        entity={active.entity}
        value={item[active.key] || []}
        isMulti
        onChange={o => onChange(active.key, o || [])}
      />
    </div>
  );
}
